import React from 'react';
interface Props {
  text: string;
  maxLength: number;
}

export function ExpandableText(props: Props) {
  const [displayedText,setDisplayedText] = React.useState<string>('');
  const [showReadMore,setShowReadMore] = React.useState<boolean>(true);
  const [showReadLess,setShowReadLess] = React.useState<boolean>(false);
  React.useEffect(() => {
    if (props.text.length > props.maxLength) {
      setDisplayedText(props.text.substr(0,props.maxLength) + '...');
      setShowReadMore(true);
      setShowReadLess(false);
      return;
    }
    setShowReadMore(false);
    setShowReadLess(false);
    setDisplayedText(props.text);
  },[props]);
  return (
    <div className="ExpandableText">
      {displayedText}<br/>
      {showReadMore && (
        <button className="read-more" onClick={() => {
          setShowReadMore(false);
          setShowReadLess(true);
          setDisplayedText(props.text);
        }}>Read More</button>
      )}
      {showReadLess && (
        <button  className="read-more" onClick={() => {
          setShowReadMore(true);
          setShowReadLess(false);
          setDisplayedText(props.text.substr(0,props.maxLength) + '...');
        }}>Read Less</button>
      )}
    </div>
  );
}

